import { Form, Formik, useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineUser,
} from "react-icons/ai";
import { FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";
import i18n from "src/core/configs/i18n";
import { signinValidationSchema } from "./validation/signin-form-validation";

interface IProps {
  isParentAccount: boolean;
}
function SignInFormComponent(props: IProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isVisiable, setIsVisiable] = useState<boolean>(false);

  type InitialValuesType = {
    emailOrUserName: string;
    password: string;
  };
  const initialValues: InitialValuesType = {
    emailOrUserName: "",
    password: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async () => {},
    validationSchema: signinValidationSchema,
  });
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={formik.initialValues}
      onSubmit={() => formik.submitForm()}
      enableReinitialize
    >
      <Form
        className="flex flex-col mobile:mx-2"
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
          //for fake log in testing
          if(formik.values.emailOrUserName === 'student@test.com' && formik.values.password === 'student1234'){
          navigate(appRoutesObj.getBasePath());
          localStorage.setItem("role", "student");
          }else if(formik.values.emailOrUserName === 'school@test.com' && formik.values.password === 'school1234'){
          navigate(appRoutesObj.getBasePath());
          localStorage.setItem("role", "school");
          }
        }}
      >
        {/* Username Input */}
        <label className="relative font-arMedium text-xl text-zinc700">
          {t("app.shared.username")}
          <AiOutlineUser
            className={`${
              i18n.language === "ar" ? "right-4" : "left-4"
            } absolute bottom-[17px] text-zinc-300 text-2xl`}
          />
          <input
            placeholder="a@example.sa"
            name="emailOrUserName"
            onBlur={(e) => formik.handleBlur(e)}
            onChange={(e) => formik.handleChange(e)}
            className={`${
              i18n.language === "ar" ? "pl-4 pr-12" : "pr-4 pl-12"
            } w-[425px] mobile:w-full bg-transparent border font-arMedium text-zinc700 text-lg rounded-2xl py-3 px mt-2 placeholder-zinc-300 placeholder:font-arMedium placeholder:text-lg focus:outline-none caret-mint-500 ${
              formik.touched.emailOrUserName && formik.errors.emailOrUserName
                ? "border-secondary-50 focus:border-secondary-50"
                : "border-zinc400 focus:border-mint-500"
            }`}
          ></input>
        </label>
        {formik.touched.emailOrUserName && formik.errors.emailOrUserName && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50 pt-2">
            {formik.errors.emailOrUserName}
          </p>
        )}
        {/* Password Input */}
        <label className="relative font-arMedium text-xl text-zinc700 mt-4">
          {t("app.shared.password")}
          <FiLock
            className={`${
              i18n.language === "ar" ? "right-4" : "left-4"
            } absolute bottom-[17px] text-zinc-300 text-2xl`}
          />
          <input
            type={isVisiable ? "text" : "password"}
            placeholder="*******"
            name="password"
            onChange={(e) => formik.handleChange(e)}
            onBlur={(e) => formik.handleBlur(e)}
            className={`${
              i18n.language === "ar" ? "pl-4 pr-12" : "pr-4 pl-12"
            } w-[425px] mobile:w-full bg-transparent border font-arMedium text-zinc700 text-lg rounded-2xl py-3 mt-2 placeholder-zinc-300 placeholder:font-arMedium placeholder:text-lg focus:outline-none caret-mint-500 ${
              formik.touched.password && formik.errors.password
                ? "border-secondary-50 focus:border-secondary-50"
                : "border-zinc400 focus:border-mint-500"
            }`}
          ></input>
          {!isVisiable ? (
            <AiOutlineEyeInvisible
              onClick={() => setIsVisiable(!isVisiable)}
              className={`${
                i18n.language === "ar" ? "left-4" : "right-4"
              } absolute bottom-4 text-zinc-300 text-2xl cursor-pointer`}
            />
          ) : (
            <AiOutlineEye
              onClick={() => setIsVisiable(!isVisiable)}
              className={`${
                i18n.language === "ar" ? "left-4" : "right-4"
              } absolute bottom-4 text-zinc-300 text-2xl cursor-pointer`}
            />
          )}
        </label>
        {formik.touched.password && formik.errors.password && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50 pt-2">
            {formik.errors.password}
          </p>
        )}
        {/* remember me */}
        {/* did you forget password? */}
        <div className="flex flex-row items-center justify-between mx-2">
          <div className="flex gap-2 py-4">
            <input type="checkbox" className="cursor-pointer"></input>
            <div className="font-arMedium text-xl text-zinc600">
              {t("signInForm.component.rememeberMe")}
            </div>
          </div>
          <div
            onClick={() => navigate(appRoutesObj.getForgetPasswordPagePath())}
            className="font-arMedium text-base text-mint-500 cursor-pointer"
          >
            {t("signInForm.component.forgotPassword")}
          </div>
        </div>
        {/* Sign-in Button */}
        <div className="flex flex-col justify-center items-center">
          <button
            onClick={
              () => {}
            }
            type="submit"
            className="flex justify-center items-center font-arMedium text-2xl mobile:text-xl text-zinc50 bg-mint-500 h-14 w-[345px] mobile:w-full rounded-2xl mt-14"
          >
            {t("app.shared.signin")} 
          </button>
          {/* don't have an account? */}
          <span className="pt-3 font-arRegular text-sm">
            {t("signInForm.component.dontHaveAccount")}
            {props.isParentAccount ? (
              <span
                onClick={() =>
                  navigate(appRoutesObj.getSchoolRegisterPagePath())
                }
                className="text-mint-500 cursor-pointer"
              >
                {t("signInForm.component.createSchoolOfficialAccount")}
              </span>
            ) : (
              <span
                onClick={() => navigate(appRoutesObj.getRegisterPagePath())}
                className="text-mint-500 cursor-pointer"
              >
                {t("signInForm.component.createParentAccount")}
                
              </span>
            )}
          </span>
        </div>
      </Form>
    </Formik>
  );
}

export default SignInFormComponent;
